export default __webpack_public_path__ + "images/260a56d2d5b5c55f322188785da0a6d3.png";